var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"information-unit",attrs:{"contenteditable":"false"},on:{"click":_vm.test}},[_vm._v("Testing Information Unit")])}
var staticRenderFns = []
export { render, staticRenderFns }